function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickCopeImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3000 2000",
    style: {
      enableBackground: "new 0 0 3000 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3000,
    height: 2000
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 844.414,
    y: 162.031,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 54.1635 685.9578)",
    style: {
      fill: "#DADADA"
    },
    width: 21.383,
    height: 231.134
  }), /*#__PURE__*/React.createElement("rect", {
    x: 739.539,
    y: 266.906,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 54.1647 685.9602)",
    style: {
      fill: "#DADADA"
    },
    width: 231.134,
    height: 21.383
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M1080.114,540.088l-117.019-80.067H630.1V127.613h450.014V540.088z M641.763,448.358h324.942 l101.745,69.616V139.277H641.763V448.358z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6F5F5"
    },
    d: "M797.267,744.729c-14.671-79.184-93.721-149.167-187.282-174.759 c-96.33-26.347-207.724,16.004-262.802,86.451c-43.033,55.041-55.9,125.937-32.295,188.502 c23.592,62.527,83.768,115.225,158.616,136.698c139.256,39.952,270.379-49.675,314.822-155.216 C799.853,799.032,802.201,771.36,797.267,744.729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6F5F5"
    },
    d: "M2666.032,1202.731c-84.392-311.123-345.258-602.238-692.285-548.73 c-22.911,3.533-45.578,8.634-67.808,15.234c-259.529,77.053-377.767,318.971-507.123,533.605 c-62.03,102.924-146.832,217.524-276.587,227.545c-120.947,9.341-227.843-79.411-347.745-97.898 c-143.626-22.145-280.345,71.187-348.427,193.614c-78.072,140.39-55.499,295.944,19.604,425.765h2027.094 C2655.032,1757.954,2737.441,1465.988,2666.032,1202.731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6F5F5"
    },
    d: "M445.572,1953.721c-157.568-190.75-178.227-458.958-48.055-623.887 c56.68-71.809,136.977-116.367,232.207-128.856c107.725-14.112,230.242,12.034,364.198,77.726l-2.568,5.239 c-132.905-65.185-254.327-91.166-360.87-77.179c-93.695,12.284-172.671,56.091-228.388,126.686 c-128.509,162.816-107.887,427.88,47.969,616.557L445.572,1953.721z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6F5F5"
    },
    d: "M2495.299,1955.914c-7.557,0-15.16-0.381-22.837-1.15l0.581-5.797 c115,11.447,217.26-66.586,273.465-208.894c85.784-217.198,50.111-544.999-184.964-724.689l3.542-4.636 c237.353,181.433,273.414,512.281,186.843,731.466C2698.442,1877.641,2603.642,1955.903,2495.299,1955.914z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M2529.515,1609.034h-361.96v-151.802h361.96V1609.034z M2176.302,1600.287h344.465V1465.98 h-344.465V1600.287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M2347.718,1465.98h-361.96v-151.802h361.96V1465.98z M1994.505,1457.233h344.465v-134.306 h-344.465V1457.233z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M756.672,1049.188h-361.96V897.387h361.96V1049.188z M403.46,1040.441h344.465V906.135H403.46 V1040.441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M574.87,906.135h-361.96V754.33h361.96V906.135z M221.657,897.387h344.465V763.078H221.657 V897.387z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M936.172,1752.236h-361.96v-151.802h361.96V1752.236z M582.959,1743.489h344.465v-134.306H582.959 V1743.489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M2598.214,795.833h-361.96V644.029h361.96V795.833z M2245.002,787.085h344.465V652.776h-344.465 V787.085z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M187.86,1448.986c-16.348,0-29.646-13.298-29.646-29.643c0-16.35,13.298-29.648,29.646-29.648 c16.348,0,29.646,13.298,29.646,29.648C217.505,1435.689,204.207,1448.986,187.86,1448.986z M187.86,1398.443 c-11.524,0-20.898,9.374-20.898,20.901c0,11.521,9.374,20.895,20.898,20.895c11.524,0,20.898-9.374,20.898-20.895 C208.758,1407.817,199.384,1398.443,187.86,1398.443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M290.886,457.593c-16.345,0-29.643-13.298-29.643-29.646c0-16.345,13.298-29.643,29.643-29.643 c16.348,0,29.646,13.298,29.646,29.643C320.531,444.295,307.234,457.593,290.886,457.593z M290.886,407.052 c-11.521,0-20.895,9.374-20.895,20.895c0,11.524,9.374,20.898,20.895,20.898c11.524,0,20.898-9.374,20.898-20.898 C311.784,416.426,302.41,407.052,290.886,407.052z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M2155.094,1849.434c-16.345,0-29.643-13.298-29.643-29.648c0-16.345,13.298-29.643,29.643-29.643 c16.35,0,29.648,13.298,29.648,29.643C2184.743,1836.136,2171.445,1849.434,2155.094,1849.434z M2155.094,1798.89 c-11.521,0-20.895,9.374-20.895,20.895c0,11.527,9.374,20.901,20.895,20.901c11.527,0,20.901-9.374,20.901-20.901 C2175.995,1808.264,2166.621,1798.89,2155.094,1798.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M2777.147,966.895c-16.345,0-29.643-13.298-29.643-29.643c0-16.345,13.298-29.643,29.643-29.643 c16.345,0,29.643,13.298,29.643,29.643C2806.79,953.597,2793.492,966.895,2777.147,966.895z M2777.147,916.357 c-11.521,0-20.895,9.374-20.895,20.895c0,11.521,9.374,20.895,20.895,20.895c11.521,0,20.895-9.374,20.895-20.895 C2798.042,925.731,2788.668,916.357,2777.147,916.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M1894.614,123.239c-16.351,0-29.648-13.298-29.648-29.643c0-16.348,13.298-29.646,29.648-29.646 c16.345,0,29.643,13.298,29.643,29.646C1924.257,109.941,1910.959,123.239,1894.614,123.239z M1894.614,72.699 c-11.527,0-20.901,9.374-20.901,20.898c0,11.521,9.374,20.895,20.901,20.895c11.521,0,20.895-9.374,20.895-20.895 C1915.509,82.073,1906.135,72.699,1894.614,72.699z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M2743.347,402.26h-257.633c-25.069,0-45.463-20.397-45.463-45.466V295.05 c0-25.07,20.394-45.466,45.463-45.466h257.633c25.07,0,45.464,20.397,45.464,45.466v61.743 C2788.811,381.863,2768.417,402.26,2743.347,402.26z M2485.714,258.332c-20.246,0-36.716,16.473-36.716,36.719v61.743 c0,20.246,16.47,36.719,36.716,36.719h257.633c20.246,0,36.716-16.473,36.716-36.719V295.05c0-20.246-16.47-36.719-36.716-36.719 H2485.714z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#DADADA"
    },
    cx: 2530.175,
    cy: 325.921,
    r: 17.051
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#DADADA"
    },
    cx: 2614.531,
    cy: 325.921,
    r: 17.051
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#DADADA"
    },
    cx: 2698.886,
    cy: 325.921,
    r: 17.051
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D69ED"
    },
    d: "M1818.819,1951.973h-664c-3.266-84.619,3.266-191.047,15.221-287.329 c12.072-98.381,29.742-186.265,48.17-229.77l112.669-4.957l415.102-18.37c1.925,4.024,3.849,8.281,5.657,12.83 c18.311,45.313,31.549,115.643,41.288,192.681C1807.797,1734.624,1814.504,1867.879,1818.819,1951.973z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1476.673,
    y: 1444.568,
    transform: "matrix(0.9997 -0.0231 0.0231 0.9997 -36.8744 34.6908)",
    style: {
      fill: "#102048"
    },
    width: 11.661,
    height: 336.388
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#4737A0"
    },
    d: "M1792.926,1617.057c-70.214,10.089-303.366,40.297-622.887,47.587 c12.072-98.381,29.742-186.265,48.17-229.77l112.669-4.957l420.759-5.54C1769.949,1469.689,1783.187,1540.02,1792.926,1617.057z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E28B6D"
    },
    d: "M1113.238,1291.53c-32.725,52.89-65.624,100.512-99.198,127.832l-77.776-180.803l141.905-58.317 L1113.238,1291.53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E28B6D"
    },
    d: "M1822.085,1257.647l51.436,68.698c25.543,34.057,65.607,54.119,108.12,54.119 c30.5,0,59.192-10.264,82.169-27.818c22.977-17.612,40.297-42.63,48.229-72.08l33.357-123.633l-143.869-58.337l-130.242,33.047 L1822.085,1257.647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F3C88"
    },
    d: "M1987.939,1079.138l-3.907,54.469l-161.947,124.041l-133.546-178.51l-412.07,1.983 l-163.23,210.409l-211.983-86.018c180.784-363.492,417.96-456.799,598.743-452.951 C1575.811,760.376,1847.978,775.888,1987.939,1079.138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F3C88"
    },
    d: "M1196.749,1045.139l-35.654,515.609c-1.211,17.513,12.841,32.304,30.393,31.99l588.091-10.502 c17.469-0.312,30.958-15.458,29.253-32.846l-55.154-562.569L1196.749,1045.139z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1036.905,
    y: 1162.745,
    transform: "matrix(0.0762 -0.9971 0.9971 0.0762 -64.9783 2267.0217)",
    style: {
      fill: "#102048"
    },
    width: 308.024,
    height: 11.663
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1762.425,
    y: 988.571,
    transform: "matrix(0.9928 -0.1196 0.1196 0.9928 -124.9827 219.7575)",
    style: {
      fill: "#102048"
    },
    width: 11.667,
    height: 325.02
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A6BEA"
    },
    d: "M1471.515,963.415c-58.875,0-97.593-39.005-98.174-39.603l8.38-8.115 c3.306,3.406,82.293,82.43,187.49-3.372l7.369,9.032C1537.837,952.971,1501.972,963.415,1471.515,963.415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A6BEA"
    },
    d: "M1674.104,1071.382h-104.735c-2.883,0-5.221-2.337-5.221-5.221v-37.67 c0-2.883,2.337-5.221,5.221-5.221h104.735c2.883,0,5.221,2.337,5.221,5.221v37.67 C1679.324,1069.045,1676.987,1071.382,1674.104,1071.382z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B384"
    },
    d: "M2137.966,974.111c-23.941,4.788-74.98,15.465-94.117,34.039 c-2.092-10.766-6.663-22.252-13.379-32.919c-19.036-30.233-55.987-48.149-75.023-24.634 c-19.036,23.514-39.597,237.335,59.347,249.703c68.537,8.567,109.728-10.17,130.607-24.881 c20.501-1.272,40.837-8.346,50.136-28.298c1.286-2.759,0.943-5.351-0.66-7.762c6.593-9.217,14.631-22.906,14.785-35.145 c0.064-5.111-1.806-9.597-5.329-13.49c2.48-7.643,4.588-16.495,4.693-24.823c0.086-6.845-3.307-12.565-9.518-17.232 c5.457-7.746,11.309-17.758,13.48-27.528C2217.468,1000.985,2210.75,959.555,2137.966,974.111z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2008.542,
    y: 659.273,
    style: {
      fill: "#1F3C88"
    },
    width: 128.298,
    height: 484.033
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2008.542,
    y: 659.273,
    style: {
      fill: "#102048"
    },
    width: 128.298,
    height: 210.538
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EB5D60"
    },
    cx: 2072.691,
    cy: 548.26,
    r: 253.891
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1882.421,587.65l10.179-23.042c8.848,5.226,20.631,8.575,30.952,8.575 c8.979,0,12.197-1.877,12.197-5.095c0-11.788-51.855-2.275-51.855-37.247c0-17.418,14.598-31.622,43.673-31.622 c12.601,0,25.595,2.678,35.381,8.177l-9.514,22.911c-9.252-4.691-17.958-6.972-26.129-6.972 c-9.252,0-12.197,2.684-12.197,5.897c0,11.254,51.855,1.877,51.855,36.445c0,17.15-14.609,31.622-43.683,31.622 C1907.612,597.3,1891.793,593.416,1882.421,587.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1995.415,525.883h-27.471v-24.52h86.56v24.52h-27.471v69.273h-31.617V525.883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2057.624,548.26c0-28.404,22.376-49.04,52.924-49.04c30.548,0,52.924,20.636,52.924,49.04 s-22.376,49.04-52.924,49.04C2080,597.3,2057.624,576.664,2057.624,548.26z M2131.583,548.26 c0-14.603-9.372-23.445-21.034-23.445c-11.652,0-21.034,8.842-21.034,23.445s9.383,23.451,21.034,23.451 C2122.211,571.711,2131.583,562.863,2131.583,548.26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2262.96,536.739c0,21.705-16.616,35.37-42.745,35.37h-13.539v23.047h-31.617v-93.793h45.156 C2246.344,501.363,2262.96,515.033,2262.96,536.739z M2231.071,536.739c0-6.835-4.157-10.986-12.863-10.986h-11.532v21.973 h11.532C2226.914,547.725,2231.071,543.568,2231.071,536.739z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B384"
    },
    d: "M2137.966,974.111c-33.232,6.646-118.693,24.634-98.538,59.346 c0.853,1.469,2.036,2.704,3.455,3.768c-15.274,3.519-26.832,9.49-28.445,19.5c-1.851,11.49,12.841,19.629,32.987,25.371 c-15.3,5.01-26.435,12.287-26.227,22.803c0.187,9.464,13.128,15.802,30.593,20.061c-6.179,2.417-10.451,5.889-11.405,10.836 c-5.004,25.942,45.325,31.308,62.186,35.428c25.278,6.176,76.475,11.277,92.965-24.103c1.286-2.759,0.943-5.351-0.66-7.762 c6.593-9.217,14.631-22.906,14.785-35.145c0.064-5.111-1.806-9.597-5.329-13.49c2.48-7.643,4.588-16.495,4.693-24.823 c0.086-6.845-3.307-12.565-9.518-17.232c5.457-7.746,11.309-17.758,13.48-27.528 C2217.468,1000.985,2210.75,959.555,2137.966,974.111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E28B6D"
    },
    d: "M2036.905,1034.922c-3.964-6.823-4.505-13.537-1.612-19.95 c10.354-22.957,63.226-35.947,102.101-43.721c32.228-6.452,55.265-2.876,68.466,10.604c11.322,11.567,12.58,28.202,9.978,39.917 l-5.695-1.264c2.272-10.223,1.241-24.671-8.452-34.569c-11.566-11.817-33.401-14.91-63.158-8.97 c-21.664,4.334-87.607,17.524-97.926,40.401c-2.101,4.664-1.663,9.448,1.344,14.625L2036.905,1034.922z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E28B6D"
    },
    d: "M2121.983,1035.384l-1.515-5.627c20.246-5.456,36.505-11.299,36.665-11.362l1.982,5.49 C2158.95,1023.942,2142.463,1029.871,2121.983,1035.384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E28B6D"
    },
    d: "M2041.552,1083.37c-21.675-6.959-31.767-16.083-29.996-27.109 c4.351-26.995,66.512-27.849,112.916-26.106c2.193,0.08,3.992,0.148,5.313,0.177c34.279,0.82,59.132,6.435,71.883,16.248 l-3.554,4.624c-11.766-9.055-35.44-14.255-68.466-15.041c-1.344-0.034-3.166-0.103-5.393-0.182 c-68.255-2.517-104.259,4.602-106.942,21.203c-1.549,9.647,13.298,16.55,26.026,20.639L2041.552,1083.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E28B6D"
    },
    d: "M2047.492,1126.88c-19.466-5.268-29.022-12.438-29.21-21.926 c-0.097-5.006,1.925-9.613,6.014-13.685c20.297-20.212,90.044-23.059,106.127-22.626c53.254,1.27,82.43,13.919,82.157,35.605 l-5.832-0.068c0.222-17.712-27.649-28.538-76.462-29.705c-13.042-0.285-82.937,2.073-101.873,20.929 c-2.961,2.944-4.368,6.031-4.3,9.437c0.125,6.361,8.736,12.039,24.904,16.413L2047.492,1126.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E28B6D"
    },
    d: "M2098.571,1164.866c-20.548,0-44.501-2.511-55.23-12.985c-4.562-4.448-6.532-9.966-5.855-16.396 c2.13-20.195,46.454-19.876,84.822-17.347c2.397,0.159,4.357,0.291,5.763,0.359c28.686,1.333,62.03,7.216,69.588,19.711 c1.942,3.206,2.124,6.714,0.524,10.143l-5.285-2.46c0.78-1.68,0.712-3.115-0.228-4.664 c-5.086-8.411-31.761-15.365-64.872-16.909c-1.429-0.063-3.428-0.194-5.872-0.359c-50.977-3.349-77.436,0.718-78.643,12.142 c-0.484,4.624,0.86,8.423,4.129,11.607c18.218,17.774,84.759,9.323,85.437,9.232l0.752,5.786 C2132.263,1162.896,2116.749,1164.866,2098.571,1164.866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B384"
    },
    d: "M2027.129,1050.271c-24.668,7.814-52.661-41.464-52.661-41.464l-24.785-45.487 c1.866-5.948,3.849-10.322,5.773-12.713c19.011-23.502,55.985-5.599,74.996,24.61 C2049.522,1005.484,2051.738,1042.398,2027.129,1050.271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E28B6D"
    },
    d: "M2021.699,1054.018c-24.597,0.006-48.67-41.842-49.763-43.772l5.068-2.882 c7.472,13.138,30.993,45.942,49.239,40.127c6.703-2.141,11.39-6.754,13.919-13.702c5.291-14.505,0.507-36.887-12.176-57.019 c-12.176-19.346-31.494-33.003-48.078-33.988c-9.101-0.57-16.567,2.711-22.188,9.659l-4.533-3.668 c6.777-8.377,16.123-12.438,27.063-11.811c18.378,1.088,39.541,15.838,52.668,36.699c13.611,21.601,18.606,45.987,12.728,62.127 c-3.138,8.605-9.237,14.574-17.632,17.262C2025.913,1053.71,2023.806,1054.018,2021.699,1054.018z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4ABAF"
    },
    d: "M1671.143,383.655c-2.03,44.669-44.992,88.381-89.661,86.351 c-44.669-2.03-79.235-39.888-77.205-84.557c2.03-44.669,40.1-83.915,84.77-81.884 C1633.715,305.595,1673.173,338.986,1671.143,383.655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4ABAF"
    },
    d: "M1610.266,482.403c-13.452,0-29.489-3.027-48.567-10.533l2.13-5.427 c72.538,28.541,97.767-11.185,105.244-29.589c13.6-33.495,4.288-78.839-18.11-88.213l2.255-5.382 c25.463,10.661,36.192,59.001,21.26,95.788C1668.356,454.124,1651.379,482.403,1610.266,482.403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B384"
    },
    d: "M1562.923,574.111l-3.382,74.937l-6.415,140.72c-2.216,48.229-43.096,85.61-91.325,83.394 c-48.229-2.216-85.551-43.097-83.394-91.325l1.808-40.239l5.948-130.981l2.041-44.438L1562.923,574.111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E28B6D"
    },
    d: "M1562.923,574.111l-3.382,74.937c-23.269-7.523-32.308-41.288-32.308-41.288L1562.923,574.111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E28B6D"
    },
    d: "M1498.074,655.405c0,0-36.565,62.458-117.859,86.193l5.948-130.981l82.752,21.461 L1498.074,655.405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCCCD"
    },
    d: "M1311.007,540.771c0,0-46.275-42.962-28.258-129.89c18.017-86.928,161.229-108.772,240.121-51.38 c66.784,48.583,93.734,104.063,55.512,193.422L1311.007,540.771z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B384"
    },
    d: "M1314.166,427.045c0,0-29.653,210.316,12.763,249.753c30.255,28.131,101.421,38.1,198.648-37.859 l17.196-172.032l-122.568-73.892L1314.166,427.045z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCCCD"
    },
    d: "M1519.282,547.631c-37.215-64.826-151.781-2.004-221.245-98.594l15.825-59.515l121.474-19.932 l73.711,28.803l64.049,64.534l-1.306,72.951L1519.282,547.631z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.36 -0.9329 0.9329 0.36 461.1438 1800.1698)",
    style: {
      fill: "#F9B384"
    },
    cx: 1542.723,
    cy: 563.955,
    rx: 59.186,
    ry: 42.276
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#102048"
    },
    d: "M1533.053,576.195c-0.182,0-0.365-0.011-0.552-0.034c-2.409-0.302-4.118-2.5-3.816-4.909 c1.874-14.924,15.399-26.636,29.443-25.579c2.42,0.182,4.237,2.292,4.055,4.716c-0.188,2.426-2.312,4.22-4.715,4.055 c-8.463-0.663-18.611,6.401-20.058,17.902C1537.13,574.569,1535.234,576.195,1533.053,576.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#102048"
    },
    d: "M1347.477,529.575c-0.696,5.544-5.754,9.474-11.298,8.778 c-5.544-0.696-9.474-5.754-8.778-11.298c0.696-5.544,5.754-9.474,11.298-8.778 C1344.243,518.973,1348.173,524.031,1347.477,529.575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#102048"
    },
    d: "M1426.251,536.929c-0.712,5.671-5.886,9.691-11.556,8.979 c-5.671-0.712-9.691-5.886-8.979-11.556c0.712-5.671,5.886-9.691,11.556-8.979 C1422.943,526.084,1426.963,531.258,1426.251,536.929z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#102048"
    },
    d: "M1361.851,597.697c-1.293,0-2.574-0.57-3.443-1.66c-7.076-8.89-9.425-16.817-6.979-23.558 c2.423-6.686,8.907-10,12.885-11.453l1.541-19.11c0.197-2.423,2.383-4.186,4.735-4.029c2.42,0.197,4.226,2.315,4.029,4.736 l-1.783,22.097c-0.157,1.948-1.58,3.559-3.497,3.952c-2.158,0.464-8.141,2.603-9.656,6.831 c-1.635,4.57,2.144,10.712,5.604,15.061c1.512,1.899,1.199,4.664-0.703,6.176 C1363.776,597.383,1362.811,597.697,1361.851,597.697z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#102048"
    },
    d: "M1373.671,634.569c-10.109,0-16.35-2.016-16.829-2.178c-2.064-0.692-3.175-2.922-2.483-4.983 c0.689-2.062,2.91-3.167,4.972-2.489l0,0c0.202,0.063,20.089,6.344,46.865-5.453c2.005-0.88,4.314,0.023,5.191,2.013 c0.877,1.99-0.026,4.314-2.013,5.191C1395.224,632.906,1382.851,634.569,1373.671,634.569z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8855 -0.4647 0.4647 0.8855 -103.219 746.6373)",
    style: {
      opacity: 0.4,
      fill: "#EB5D60"
    },
    cx: 1463.186,
    cy: 582.732,
    rx: 29.146,
    ry: 29.146
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B384"
    },
    d: "M910.994,948.916l125.495,324.062c16.511,42.637,14.805,119.881-22.467,146.364l0,0 c-50.896,36.163-122.466,17.489-148.463-39.277c-39.53-86.317-83.939-236.334-112.021-372.831c0,0-61.498-98.654-67.065-129.27 c-1.944-10.691,17.495-22.355,17.495-22.355s-2.916-35.962,0.972-39.85c3.888-3.888,17.495-6.804,17.495-6.804 s-1.944-18.467,6.804-25.271c8.748-6.804,43.738-21.383,43.738-21.383s-28.187-128.298-19.439-133.158 c8.748-4.86,25.271-19.439,69.009,125.382c0,0,58.317,21.383,68.037,28.187C905.543,793.184,913.91,852.692,910.994,948.916z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E28B6D"
    },
    d: "M860.681,828.81c-12.048-8.751-72.153-53.118-72.153-67.481c0-3.127,1.259-5.792,3.642-7.711 c8.283-6.663,28.706-2.446,31.001-1.942l-1.244,5.695c-7.648-1.669-21.487-2.93-26.103,0.792 c-1.011,0.817-1.464,1.794-1.464,3.167c0,7.586,35.463,37.866,69.75,62.759L860.681,828.81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E28B6D"
    },
    d: "M847.335,874.541c-7.441,0.003-20.798-3.044-23.933-6.179 c-2.97-2.97-22.362-28.501-24.563-31.402l4.647-3.525c8.548,11.268,22.003,28.768,24.039,30.805 c2.603,2.269,19.067,5.641,22.678,4.183c1.039-7.119-8.642-53.377-10.012-57.577l5.536-1.842 c0.174,0.524,13.577,57.21,9.283,62.933c-1.13,1.506-3.141,2.344-6.145,2.557C848.391,874.527,847.876,874.541,847.335,874.541z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E28B6D"
    },
    d: "M803.682,915.104c-11.866,0-28.316-16.123-34.287-28.062l5.217-2.608 c6.418,12.834,22.467,25.904,30.07,24.765c0.863-0.148,3.497-0.581,4.283-6.358c5.032-36.901-17.185-96.765-24.665-98.769 c-7.549-0.715-46.89,5.348-61.387,7.76l-0.957-5.752c2.156-0.359,53.01-8.762,62.976-7.802c2.082,0.208,4.157,1.663,6.353,4.445 c11.954,15.16,27.866,68.597,23.461,100.905c-1.193,8.739-6.222,10.846-9.112,11.325 C805.001,915.053,804.349,915.104,803.682,915.104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E28B6D"
    },
    d: "M769.848,933.363c-2.338,0-4.943-0.33-7.745-1.15c-9.18-2.688-22.464-11.208-33.592-36.554 l5.342-2.346c10.223,23.29,21.897,30.967,29.888,33.302c6.424,1.879,10.971,0.473,12.478-0.535 c2.728-5.063-8.278-57.702-16.359-69.824c-4.573-6.857-35.025-2.85-55.185,2.181l-1.412-5.655 c8.773-2.195,52.958-12.492,61.45,0.239c6.208,9.311,23.802,71.869,14.742,77.911 C777.479,932.246,774.116,933.363,769.848,933.363z"
  }))), /*#__PURE__*/React.createElement("rect", {
    y: 1948.949,
    style: {
      fill: "#102048"
    },
    width: 3000,
    height: 5.832
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickCopeImage);
export default __webpack_public_path__ + "static/media/QuickCopeImage.bce232fd481c4645a3d0f86d8c49e397.svg";
export { ForwardRef as ReactComponent };